<div class="pb-wrap">
  <div class="pb-search-box">
    <i class="ri-search-line"></i>
    <input type="text" [ngModel]="searchTerm" (ngModelChange)="onSearchInput($event)" placeholder="{{ 'searchByName' | translate }}" />
    <i class="ri-close-line pb-search-clear" *ngIf="searchTerm" (click)="onSearchInput('')"></i>
  </div>

  <div class="pb-tabs">
    <button type="button" class="pb-tab" [class.active]="activeFilter === 'ALL'" (click)="setFilter('ALL')">{{ 'all' | translate }}</button>
    <button type="button" class="pb-tab" [class.active]="activeFilter === 'UNREAD'" (click)="setFilter('UNREAD')">{{ 'unread' | translate }} ({{ unreadCount }})</button>
  </div>

  <div class="pb-error" *ngIf="error">{{ error }}</div>

  <div class="pb-list" *ngIf="!loading; else pbLoading">
    <div class="pb-empty" *ngIf="!items.length && !error">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>

    <div class="pb-card" *ngFor="let item of items; trackBy: trackByBroadcastId" (click)="openDetail(item)">
      <div class="pb-card-accent"></div>
      <div class="pb-card-body">
        <div class="pb-card-top">
          <span class="pb-unread-dot" *ngIf="!item.isRead"></span>
          <div class="pb-card-title">{{ item.broadcastSubject }}</div>
        </div>
        <div class="pb-card-preview">{{ item.broadcastMessage }}</div>
        <div class="pb-card-divider"></div>
        <div class="pb-card-footer">
          <span class="pb-card-date">{{ item.sentOnDate | date: 'dd MMM, y' }} &middot; {{ item.sentOnTime }}</span>
          <span class="pb-card-attachments" *ngIf="item.broadcastMediaList?.length">
            <i class="ri-attachment-2"></i> {{ item.broadcastMediaList.length }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <ng-template #pbLoading>
    <div class="pb-list">
      <div class="pb-card pb-card-skeleton" *ngFor="let n of [1,2,3,4,5,6]"></div>
    </div>
  </ng-template>

  <div class="pb-pagination" *ngIf="!loading && items.length && maxPageNumber > 1">
    <button type="button" class="pb-page-btn" [disabled]="currentPage <= 1" (click)="goToPrevPage()">
      <i class="ri-arrow-left-s-line"></i> {{ 'previous' | translate }}
    </button>
    <span class="pb-page-indicator">{{ currentPage }} / {{ maxPageNumber }}</span>
    <button type="button" class="pb-page-btn" [disabled]="currentPage >= maxPageNumber" (click)="goToNextPage()">
      {{ 'next' | translate }} <i class="ri-arrow-right-s-line"></i>
    </button>
  </div>
</div>

<!-- Detail preview — a side-anchored popover panel (web stand-in for RBSheet) -->
<div class="pb-sheet-overlay" *ngIf="selectedItem as item" (click)="closeDetail()">
  <div class="pb-sheet" (click)="$event.stopPropagation()">
    <div class="pb-sheet-header">
      <h3 class="pb-sheet-title">{{ item.broadcastSubject }}</h3>
      <button type="button" class="pb-sheet-close" (click)="closeDetail()"><i class="ri-close-line"></i></button>
    </div>
    <div class="pb-sheet-meta">{{ item.sentOnDate | date: 'dd MMM, y' }} &middot; {{ item.sentOnTime }}</div>
    <div class="pb-sheet-body">
      <p class="pb-sheet-message">{{ item.broadcastMessage }}</p>

      <ng-container *ngIf="item.broadcastMediaList?.length">
        <div class="pb-sheet-attachments-title">{{ 'attachments' | translate }}</div>
        <button type="button" class="pb-sheet-attachment-row" *ngFor="let media of item.broadcastMediaList" (click)="openAttachment(media)">
          <i class="ri-image-line" *ngIf="isImageMedia(media)"></i>
          <i class="ri-file-pdf-2-line" *ngIf="!isImageMedia(media)"></i>
          <span>{{ 'attachment' | translate }}</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>

<!-- Attachment image preview — small centered window, same pattern as diary/leave-request -->
<div class="pb-viewer-overlay" *ngIf="imageViewerUrl" (click)="closeImageViewer()">
  <div class="pb-image-viewer-window" (click)="$event.stopPropagation()">
    <button type="button" class="pb-viewer-close" (click)="closeImageViewer()"><i class="ri-close-line"></i></button>
    <img [src]="imageViewerUrl" class="pb-image-viewer-img" alt="" />
  </div>
</div>

<!-- Attachment PDF preview -->
<div class="pb-viewer-overlay" *ngIf="pdfViewerUrl" (click)="closePdfViewer()">
  <div class="pb-pdf-viewer-window" (click)="$event.stopPropagation()">
    <button type="button" class="pb-viewer-close pb-viewer-close-light" (click)="closePdfViewer()"><i class="ri-close-line"></i></button>
    <iframe [src]="pdfViewerUrl" class="pb-pdf-viewer-frame"></iframe>
  </div>
</div>
